import { createAction, props } from '@ngrx/store';
import { JobModels } from '@models/job.models';

export const resetToInitialState = createAction('[JOB] Reset to Initial state');

export const beforeGetJobs = createAction('[JOB] Before Get Jobs');
export const getJobs = createAction('[JOB] Get Jobs');
export const getJobsSuccess = createAction('[JOB] Get Jobs Success',
  props<{
    documents: JobModels.Document[]
  }>());

export const setListLoader = createAction(
  '[JOB] Set list loader',
  props<{
    loading: boolean
  }>());

export const setQueues = createAction(
  '[JOB] Set Queues',
  props<{
    queues: string[]
  }>());


export const removeJob = createAction('[JOB] Remove Job', props<{
  qName: string,
  jobId: string
}>());
export const removeJobSuccess = createAction('[JOB] Remove Job Success',
  props<{
    jobId: string
  }>());
export const cleanRemovingId = createAction('[JOB] Set Removing Id',
  props<{
    jobId: string
  }>());
